export default __webpack_public_path__ + "static/media/e1e368f2f975453a62d04c9ad5aec899.png";